interface CopyIconProps {
  size?: number;
  color?: string;
}

const CopyIcon = ({size = 16, color = "currentColor"}: CopyIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 25 25" fill="none">
      <mask id="mask0_554_2411" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.5" y="0.75" width="24" height="24" fill="#FFFFFF" />
      </mask>
      <g mask="url(#mask0_554_2411)">
        <path d="M19.5 19.75H8.5C7.95 19.75 7.47917 19.5542 7.0875 19.1625C6.69583 18.7708 6.5 18.3 6.5 17.75V3.75C6.5 3.2 6.69583 2.72917 7.0875 2.3375C7.47917 1.94583 7.95 1.75 8.5 1.75H14.675C14.9417 1.75 15.1958 1.8 15.4375 1.9C15.6792 2 15.8917 2.14167 16.075 2.325L20.925 7.175C21.1083 7.35833 21.25 7.57083 21.35 7.8125C21.45 8.05417 21.5 8.30833 21.5 8.575V17.75C21.5 18.3 21.3042 18.7708 20.9125 19.1625C20.5208 19.5542 20.05 19.75 19.5 19.75ZM19.5 8.75H16C15.5833 8.75 15.2292 8.60417 14.9375 8.3125C14.6458 8.02083 14.5 7.66667 14.5 7.25V3.75H8.5V17.75H19.5V8.75ZM4.5 23.75C3.95 23.75 3.47917 23.5542 3.0875 23.1625C2.69583 22.7708 2.5 22.3 2.5 21.75V8.75C2.5 8.46667 2.59583 8.22917 2.7875 8.0375C2.97917 7.84583 3.21667 7.75 3.5 7.75C3.78333 7.75 4.02083 7.84583 4.2125 8.0375C4.40417 8.22917 4.5 8.46667 4.5 8.75V21.75H14.5C14.7833 21.75 15.0208 21.8458 15.2125 22.0375C15.4042 22.2292 15.5 22.4667 15.5 22.75C15.5 23.0333 15.4042 23.2708 15.2125 23.4625C15.0208 23.6542 14.7833 23.75 14.5 23.75H4.5Z" fill={color} />
      </g>
    </svg>
  )
}

export default CopyIcon;